import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import MainCard from '../MainCard';

const AuthCard = ({ children, ...other }) => (
    <MainCard
        sx={{
            width: '100%',
            maxWidth: { xs: 400, lg: 475 },
            maxHeight: { xs: 'calc(100dvh - 16px)', sm: 'calc(100dvh - 32px)' },
            margin: 0,
            '& > *': {
                flexGrow: 1,
                flexBasis: '50%'
            },
            overflowX: 'hidden',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            WebkitOverflowScrolling: 'touch',
            scrollbarGutter: 'stable'
        }}
        content={false}
        {...other}
        boxShadow
        shadow={(theme) => theme.customShadows.z1}
    >
        <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>{children}</Box>
    </MainCard>
);

AuthCard.propTypes = {
    children: PropTypes.node
};

export default AuthCard;
